var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-4 text-center text-h6"},[(_vm.mappedIcon)?_c('div',{staticClass:"icon-circle main_color"},[_c('v-icon',{staticClass:"white--text",attrs:{"size":"32"}},[_vm._v(" "+_vm._s(_vm.mappedIcon)+" ")])],1):_c('span',[_vm._v(" "+_vm._s(_vm.field.etiqueta)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }